import { AuthBoundary } from '@/components/unholster/react-authkit'
import { useEffect, useState } from 'react'
import ApolloProviderComponent from './ApolloProvider'

function Providers({ children }: Readonly<{ children: React.ReactNode }>) {
  const [redirectURI, setRedirectURI] = useState<string>('')

  useEffect(() => {
    setRedirectURI(window.location.href)
  }, [])

  return (
    <AuthBoundary
      authUrl={`${import.meta.env.VITE_PUBLIC_BACKEND_URL}/auth`}
      redirect401={`${
        import.meta.env.VITE_PUBLIC_BACKEND_URL
      }/auth/auth?redirect_uri=${redirectURI}`}
    >
      <ApolloProviderComponent>{children}</ApolloProviderComponent>
    </AuthBoundary>
  )
}

export default Providers
